import { ColumnDef } from '@tanstack/react-table';
import { TruncatedCell } from '@/components';
import { AllergyDataRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DASH } from '../../utils/displayValues';
import { DocumentSource, DocumentType } from '../../viewer';

export const createAllergiesColumns = (): ColumnDef<AllergyDataRecord>[] => [
  {
    accessorKey: 'name',
    header: 'Allergen',
    cell: ({ row }) =>
      row.original.name === null ? (
        DASH
      ) : row.original.name ? (
        <TruncatedCell text={row.original.name} className="font-medium" />
      ) : (
        'No data available'
      ),
  },
  {
    accessorKey: 'reaction',
    header: 'Reaction',
    cell: ({ row }) =>
      row.original.reaction ? (
        <TruncatedCell text={row.original.reaction} />
      ) : (
        'No data available'
      ),
  },
  {
    id: 'sourceType',
    accessorFn: (row) => row.sourceTypes,
    header: 'Sources',
    cell: ({ row }) => {
      const sourceTypes = row.original.sourceTypes ?? [];
      if (sourceTypes.length === 0) return 'No data available';
      return sourceTypes.join(', ');
    },
  },
  {
    id: 'actions',
    enableSorting: false,
    header: '',
    cell: ({ row }) => {
      const firstSourceType = row.original.sourceTypes[0];
      return (
        <div className="flex items-center justify-end">
          <PatientDocumentViewButton
            disabled={!firstSourceType}
            documentKey={{
              source: DocumentSource.MEDICAL_DATA,
              type: DocumentType.ALLERGIES,
              allergyId: row.original.id,
              sourceType: firstSourceType,
              name: row.original.name === null ? DASH : row.original.name,
            }}
          />
        </div>
      );
    },
  },
];
